import { useEffect, useState } from "react";
import { apiFetch } from "../lib/api.js";
import PremiumLock, { usePaid } from "../components/PremiumLock.jsx";

export default function Integrations() {
  const isPaid = usePaid();
  const [feed, setFeed] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [digestSent, setDigestSent] = useState(false);

  useEffect(() => {
    if (!isPaid) return;
    apiFetch("/calendar/feed-token").then(setFeed).catch((e) => setError(e.message));
  }, [isPaid]);

  async function regenerate() {
    setBusy(true);
    setError(null);
    try {
      const res = await apiFetch("/calendar/feed-token/regenerate", { method: "POST" });
      setFeed(res);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  async function sendDigestNow() {
    setBusy(true);
    setError(null);
    setDigestSent(false);
    try {
      await apiFetch("/digest/send-now", { method: "POST" });
      setDigestSent(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="page">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        INTEGRATIONS
      </div>
      <h1 style={{ marginBottom: 32 }}>Keep it in your routine</h1>

      {!isPaid && (
        <PremiumLock title="Calendar sync and weekly email digest">
          Sync your weekly Big 3 to Google Calendar and get a weekly email digest of your Big 3
          and pattern register. Available on Conquest Premium - coming soon.
        </PremiumLock>
      )}

      {isPaid && (
        <>
          <div className="card" style={{ marginBottom: 24 }}>
            <div className="card-title" style={{ marginBottom: 8 }}>Google Calendar</div>
            <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 16 }}>
              Subscribe to a private calendar feed of your weekly Big 3. In Google Calendar, go to
              "Other calendars" &rarr; "From URL" and paste the link below. It stays in sync
              automatically as your Big 3 changes.
            </p>
            {feed && (
              <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                <input readOnly value={feed.feedUrl} style={{ flex: 1, minWidth: 220 }} onFocus={(e) => e.target.select()} />
                <button className="btn-secondary" disabled={busy} onClick={regenerate}>
                  Regenerate link
                </button>
              </div>
            )}
          </div>

          <div className="card">
            <div className="card-title" style={{ marginBottom: 8 }}>Weekly email digest</div>
            <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 16 }}>
              A weekly email summarising your Big 3 and pattern register goes out automatically.
              Send yourself a preview now.
            </p>
            <button className="btn-secondary" disabled={busy} onClick={sendDigestNow}>
              Send preview now
            </button>
            {digestSent && <p style={{ color: "var(--hold)", marginTop: 12 }}>Sent - check the server console in this dev build.</p>}
          </div>
        </>
      )}

      {error && <p style={{ color: "var(--error)", marginTop: 16 }}>{error}</p>}
    </div>
  );
}
